module.exports = __webpack_public_path__ + "img/arrow-top.01f8377d.svg";